import { storeToRefs } from 'pinia';
import {
  useDialerStore as usePiniaDialerStore,
  useDialerGetters,
  useDialerSetters,
} from './use-dialer-store';

export { useCommonProps } from './use-common-props';
export { useDialerActions } from './use-dialer-actions';
export { useAgentActionsProps, useAgentsActions } from './use-agents-actions';
export { useDialerMembers } from './use-dialer-members';
export { useConferenceMembersActions } from './use-conference-members-actions';
export { useDialerReconnectConference } from './use-dialer-reconnect-conference';

export const useDialerStore = () => {
  return {
    ...storeToRefs(usePiniaDialerStore()),
    ...useDialerGetters(),
    ...useDialerSetters(),
  };
};

